import { Move, Mover, PaymentMethod } from "@/types";
import { baseApi } from "../baseApi";
interface PaymentLinkData {
  move: Move;
  mover: Mover;
  payment_methods: PaymentMethod[];
  payment_link: {
    amount: number;
    memo: string;
    purpose: string;
    payment_intent_id: string;
    payment_intent_client_secret: string;
    processing_fee_amount: number;
    processing_fee_percentage: number;
  };
}
interface ProcessPaymentRequest {
  digest: string;
  payment_intent_id: string;
  payment_method_id?: number;
  payment_method_token?: string;
  mover_id: number;
  bill_to: {
    name?: string;
    address?: string;
    zip?: string;
    country?: string;
  };
}

const customerPaymentsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPaymentLink: builder.query<PaymentLinkData, string>({
      query: (digest) => `payments/external/link/${digest}`,
    }),
    initializeCharge: builder.mutation<
      { id: string; client_secret: string },
      { amount: number }
    >({
      query: (data) => ({
        url: "payments/external/init",
        method: "POST",
        body: { amount: data.amount },
      }),
    }),
    processPayment: builder.mutation<void, ProcessPaymentRequest>({
      query: ({
        digest,
        payment_intent_id,
        payment_method_id,
        payment_method_token,
        mover_id,
        bill_to,
      }) => ({
        url: "payments/external/process",
        method: "POST",
        body: {
          digest,
          payment_intent_id,
          payment_method_id,
          payment_method_token,
          mover_id,
          bill_to,
        },
      }),
    }),
  }),
});

export const {
  useGetPaymentLinkQuery,
  useInitializeChargeMutation,
  useProcessPaymentMutation,
} = customerPaymentsApi;

export default customerPaymentsApi;
